import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import Box from "@mui/material/Box";
import { useState } from "react";
import { TextInput } from "./Input";
import { MaskInput } from "./MaskInput";
import { PrimaryButton } from "./PrimaryButton";
import { AppContext } from "../context";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AlertField from "./Alert";


export const ContactForm = () => {
  const { updateLead } = useContext<any>(AppContext);
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState<string>('')

  const handleClose = () => {
    setOpenAlert(false)
  }
  
  const handleSubmit = (e: any) => {
    e.preventDefault() 

    const data = {
      email: e.target?.email.value,
      emailConfirm: e.target?.emailConfirm.value,
      cellphone: e.target?.cellphone.value.replace(/\D/g, ""),
      
    };
    console.log(data);
    if (!data.email) {
      setAlertMessage('Email não informado!')
      setOpenAlert(true)
    } else if (data.emailConfirm !== data.email) {
      setAlertMessage('Emails não coincidem!')
      setOpenAlert(true)
    } else if (!data.cellphone) {
      setAlertMessage('Telefone não informado!')
      setOpenAlert(true)
    } else {
      const res = updateLead(data);
      if (res) {
        history.push("/pagamento");
      }
      
    };
    }

  return (
    <Box
      style={{ width: "100vw" }}
      sx={{
        marginTop: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <form onSubmit={handleSubmit}>
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AlternateEmailOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
            <TextInput 
              id='email'
              label='Email'
            />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AlternateEmailOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
            <TextInput 
              id='emailConfirm'
              label='Confirme seu email'
            />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <ArticleOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
          <MaskInput
            mask="(99)99999-9999"
            id="cellphone"
            label="Telefone"
          />
        </Box>
        
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <PrimaryButton name="Prosseguir" />
        </Box>
      </form>
    </Box>
  );
};
